import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.string.trim";
export var getSelectorHtml = function getSelectorHtml(selector) {
  if (__CLIENT__) {
    return Array.prototype.slice.call(document.querySelectorAll(selector)).map(function (el) {
      return (el.innerHTML || '').trim();
    }).join('\n');
  }

  throw new Error('cannot use getSelectorHtml when not on the client');
};